import { Computer, AccountBalance, LocalHospital, Gavel, Factory, LocalShipping, Store, Construction, School, Build, FlashOn, HelpOutline } from '@mui/icons-material';

export const PROFILE_CONSTANTS = {
    INDUSTRIES: {
        CONSTRUCTION: 'Construction & Real Estate',
        EDUCATION: 'Education & Training',
        ENERGY: 'Energy & Utilities',
        ENTERTAINMENT: 'Media & Entertainment',
        FINANCIAL: 'Financial Services',
        HEALTHCARE: 'Healthcare & Pharmaceuticals',
        INSURANCE: 'Insurance',
        MANUFACTURING: 'Manufacturing & Industrial',
        PROFESSIONAL: 'Professional Services',
        RETAIL: 'Retail & E-commerce',
        SAAS: 'SaaS/Technology',
        TRANSPORTATION: 'Transportation & Logistics',
        OTHER: 'Other'
    },

    COMPANY_SIZES: [
        '1-10 employees',
        '11-50 employees',
        '51-200 employees',
        '201-500 employees',
        '501-1000 employees',
        '1001-5000 employees',
        '5001-10,000 employees',
        '10,001-50,000 employees',
        '50,001+ employees',
    ],

    TARGET_INDUSTRIES: {
        TECH: {
            name: 'Technology & Software',
            subIndustries: [
                'Enterprise Software',
                'IT Services',
                'Cloud Services',
                'Communications Equipment',
                'Network Infrastructure',
                'Corporate Asset Management',
                'Cybersecurity',
                'Digital Marketing',
                'Telecommunications',
                'Other Tech'
            ]
        },
        FINANCIAL: {
            name: 'Financial Services',
            subIndustries: [
                'Banking',
                'Investment Services',
                'Insurance',
                'Accounting',
                'Financial Technology',
                'Other Finance'
            ]
        },
        HEALTHCARE: {
            name: 'Healthcare & Medical',
            subIndustries: [
                'Hospitals',
                'Private Practices',
                'Medical Services',
                'Healthcare Technology',
                'Other Healthcare'
            ]
        },
        PROFESSIONAL: {
            name: 'Professional Services',
            subIndustries: [
                'Legal Services',
                'Consulting Firms',
                'Accounting Services',
                'Marketing Agencies',
                'Other Professional'
            ]
        },
        MANUFACTURING: {
            name: 'Manufacturing',
            subIndustries: [
                'Industrial Manufacturing',
                'Wholesale Distribution',
                'Consumer Goods',
                'Food & Beverage',
                'Electronics',
                'Component Manufacturing',
                'Vehicle Parts',
                'Other Manufacturing'
            ]
        },
        TRANSPORTATION: {
            name: 'Transportation & Logistics',
            subIndustries: [
                'Transportation Services',
                'Logistics Providers',
                'Warehouse Operations',
                'Supply Chain Services',
                'Distribution Services',
                'Fleet Management',
                'Other Transportation',
            ]
        },
        RETAIL: {
            name: 'Retail & Consumer',
            subIndustries: [
                'Retail Stores',
                'Restaurants',
                'Hospitality',
                'Consumer Services',
                'Wholesale Trade',
                'Other Retail'
            ]
        },
        CONSTRUCTION: {
            name: 'Construction & Real Estate',
            subIndustries: [
                'Construction Companies',
                'Real Estate Agencies',
                'Property Management',
                'Architecture Firms',
                'Other Construction/RE'
            ]
        },
        EDUCATION: {
            name: 'Education',
            subIndustries: [
                'K-12 Schools',
                'Higher Education',
                'Education Services',
                'Training Organizations',
                'Other Education'
            ]
        },
        INDUSTRIAL: {
            name: 'Industrial Equipment',
            subIndustries: [
                'Agricultural Equipment',
                'Construction Equipment',
                'Mining Equipment',
                'Industrial Machinery',
                'Manufacturing Equipment',
                'Industrial Automation Systems',
                'Process Control Equipment',
                'Other Industrial Equipment',
            ]
        },
        ENERGY: {
            name: 'Energy & Utilities',
            subIndustries: [
                'Energy Services',
                'Utility Equipment',
                'Power Generation',
                'Environmental Services',
                'Infrastructure Services',
                'Other Energy & Utilities',
            ]
        },
        OTHER: {
            name: 'Other',
            subIndustries: []
        }
    },

    DECISION_MAKER_LEVELS: [
        'C-Suite',
        'VP/Director Level',
        'Department Head/Manager',
        'Business Owner',
        'Startup Founder',
        'Other'
    ],

    DECISION_MAKER_DEPARTMENTS: [
        'Sales',
        'Marketing',
        'Operations',
        'Finance',
        'Legal',
        'HR',
        'IT',
        'Engineering',
        'Product',
        'Customer Support',
        'Supply Chain',
        'Procurement',
        'Logistics',
        'Manufacturing',
        'Facilities',
        'Transportation',
        'Other'
    ],

    GEOGRAPHIC_FOCUS_TYPES: {
        NONE: 'None',
        REGIONAL: 'Regional',
        STATE: 'State',
        COUNTRY: 'Country',
        INTERNATIONAL_REGION: 'International Region'
    },

    REGIONS: [
        'Northeast', 'Southeast', 'Midwest', 'Mid Atlantic',
        'Southwest', 'West Coast', 'Northwest'
    ],

    STATES: [
        'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California',
        'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida',
        'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana',
        'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine',
        'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
        'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
        'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
        'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
        'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah',
        'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
    ],

    COUNTRIES: [
        // North America
        'Canada', 'Mexico', 'United States',

        // Central America & Caribbean
        'Costa Rica', 'Cuba', 'Dominican Republic', 'Guatemala', 'Jamaica', 'Panama',

        // South America
        'Argentina', 'Brazil', 'Chile', 'Colombia', 'Ecuador', 'Peru', 'Uruguay', 'Venezuela',

        // Europe
        'Austria', 'Belgium', 'Croatia', 'Czech Republic', 'Denmark', 'Finland', 'France', 'Germany',
        'Greece', 'Hungary', 'Ireland', 'Italy', 'Netherlands', 'Norway', 'Poland', 'Portugal',
        'Romania', 'Russia', 'Spain', 'Sweden', 'Switzerland', 'Turkey', 'Ukraine', 'United Kingdom',

        // Africa
        'Algeria', 'Egypt', 'Ethiopia', 'Ghana', 'Kenya', 'Morocco', 'Nigeria',
        'South Africa', 'Tanzania', 'Uganda',

        // Middle East
        'Iran', 'Iraq', 'Israel', 'Jordan', 'Kuwait', 'Lebanon', 'Qatar',
        'Saudi Arabia', 'United Arab Emirates',

        // Asia
        'Bangladesh', 'China', 'India', 'Indonesia', 'Japan', 'Kazakhstan',
        'Malaysia', 'Pakistan', 'Philippines', 'Singapore', 'South Korea',
        'Sri Lanka', 'Thailand', 'Vietnam',

        // Oceania
        'Australia', 'New Zealand',

        // Central Asia / Other
        'Azerbaijan', 'Georgia', 'Uzbekistan'
    ].sort((a, b) => a.localeCompare(b)),

    INTERNATIONAL_REGIONS: [
        'Africa', 'Asia', 'Caribbean', 'Central America', 'Europe',
        'Latin America', 'Middle East', 'North America', 'Oceania', 'South America'
    ]

};

// Validation helpers
export const isValidIndustry = (industry) =>
    Object.values(PROFILE_CONSTANTS.INDUSTRIES).includes(industry);

export const isValidMarketFocus = (focus) =>
    Object.values(PROFILE_CONSTANTS.MARKET_FOCUS).includes(focus);

export const isValidCompanySize = (size) =>
    PROFILE_CONSTANTS.COMPANY_SIZES.includes(size);

export const isValidRegion = (region) =>
    PROFILE_CONSTANTS.REGIONS.includes(region);

export const isValidState = (state) =>
    PROFILE_CONSTANTS.STATES.includes(state);

export const isValidGeographicFocusType = (type) =>
    Object.values(PROFILE_CONSTANTS.GEOGRAPHIC_FOCUS_TYPES).includes(type);

export const isValidDecisionMakerLevel = (level) =>
    PROFILE_CONSTANTS.DECISION_MAKER_LEVELS.includes(level);

export const isValidConsumerDemographic = (demographic) =>
    PROFILE_CONSTANTS.CONSUMER_DEMOGRAPHICS.includes(demographic);

export const isDepartmentRequired = (level) =>
    !['Business Owner', 'Startup Founder'].includes(level);

export const industryIcon = (industry) => {
    switch (industry) {
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.TECH.name:
            return <Computer />;
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.FINANCIAL.name:
            return <AccountBalance />;
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.HEALTHCARE.name:
            return <LocalHospital />;
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.PROFESSIONAL.name:
            return <Gavel />;
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.MANUFACTURING.name:
            return <Factory />;
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.TRANSPORTATION.name:
            return <LocalShipping />;
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.RETAIL.name:
            return <Store />;
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.CONSTRUCTION.name:
            return <Construction />;
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.EDUCATION.name:
            return <School />;
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.INDUSTRIAL.name:
            return <Build />;
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.ENERGY.name:
            return <FlashOn />;
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.OTHER.name:
            return <HelpOutline />;
        default:
            return <HelpOutline />;
    }
};

export const industryColor = (industry) => {
    switch (industry) {
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.TECH.name:
            return '#bf360c'; // Even Darker Vibrant Orange
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.FINANCIAL.name:
            return '#e65100'; // Even Darker Bright Amber
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.HEALTHCARE.name:
            return '#c2185b'; // Even Darker Punchy Pink
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.PROFESSIONAL.name:
            return '#6a1b9a'; // Even Darker Deep Purple
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.MANUFACTURING.name:
            return '#4e342e'; // Even Darker Earthy Brown
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.TRANSPORTATION.name:
            return '#37474f'; // Even Darker Muted Blue Gray
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.RETAIL.name:
            return '#ff8f00'; // Even Darker Bright Yellow
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.CONSTRUCTION.name:
            return '#558b2f'; // Even Darker Vibrant Green
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.EDUCATION.name:
            return '#0277bd'; // Even Darker Bright Sky Blue
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.INDUSTRIAL.name:
            return '#f9a825'; // Even Darker Bright Lemon Yellow
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.ENERGY.name:
            return '#bf360c'; // Even Darker Fiery Orange
        case PROFILE_CONSTANTS.TARGET_INDUSTRIES.OTHER.name:
            return '#616161'; // Even Darker Neutral Gray
        default:
            return '#757575'; // Even Darker Light Gray
    }
};